import { createFileRoute } from '@tanstack/react-router';

import { BootSplash } from '~/app/boot-splash';

/**
 * The boot screen, held. A real boot lasts a moment, too short to look at the
 * mark's loop. A developer page, open to anyone.
 */
export const Route = createFileRoute('/dev/boot')({
  component: () => (
    <div className="flex h-dvh">
      <BootSplash />
    </div>
  ),
});
